import { AnalyticsSdk } from "./initLogger";
import { PdtEventPayload } from "./types";

const getExtraOptions = () => ({
  lob: "travelinsurance",
  destinationUrl: typeof window !== "undefined" ? window.location.href : "",
});

export const pushToPdtEvent = (
  eventObj: PdtEventPayload | Record<string, unknown>
) => {
  try {
    AnalyticsSdk.pushToPDT(eventObj, getExtraOptions());
  } catch (error) {
    console.error("Error pushing event to PDT Data Layer", error);
  }
};
